import {AddFormType} from 'context/guest';
import {GUEST_FORM_NAMES} from '@chekin/core';

export const sortFormNamesByOrder = (arr: GUEST_FORM_NAMES[], formFields: AddFormType) =>
  arr.sort((a, b) => formFields[a]?.order - formFields[b]?.order);
